import {
    EVENT_DELETE_ELEMENT_BY_ID,
    EVENT_FAVIRIATE_CHANGE, EVENT_NOTE_CHANGED, EVENT_NOTE_DELETE_FOREVER,
    EVENT_REFRESH_LIBRARY_LIST,
    EVENT_REFRESH_RECENTS, EVENT_REFRESH_TAG_LSIT, EVENT_RENAME_LIBRARY_ITEM, EVENT_SHOW_DESKTOP_PRO_VIP,
    FROM_DIALOG, FROM_LIBRARY, KEY_FILE_DIR
} from "../../Const";
import {
    dbGetHighlight, dbGetHighlightByLibraryId,
    deleteAllCardFromRefProject, deleteBoardById, delNote, delNoteForever, editDoc, getBoardById, getCardById,
    getCardDoc, getNoteById, getNoteJsonDoc,
    renameCard, updateBoard,
    updateCard,
    updateHighlight, updateNote, updateNoteDoc, updateNoteItemToHasUpdate
} from "../../../model";
import {ipcInvoke, ipcSend} from "../../common/ipc";
import {
    createCopyLink,
    createCopyLinkByLibraryItem,
    generateRandomPageKey,
    generateUUID2,
    getFileNameExt,
    hasBeyondFreeLimit, isInPageTag
} from "../../utils";
import Global from "../../global";
import {openEditor} from "../../state";
import { message } from "antd";
import {
    exportCurrentElementVideoNotes,
    getCurrentElementVideoNotes,
    onImportHighlights
} from "../../VideoHighlightUtils";
import { saveElementVideoNotesAsJSON } from "../../../@excalidraw/packages/excalidraw/data/json";
import clipboard from "clipboardy";
import { t } from "i18next";
import {getCardPath} from "@/Utility";
import {postMessage} from "@/common/event";
import {noteServer} from "@/common/notesServer";
import {ENoteAction} from "@/views/Note/NoteItem/NoteItemIndex";
import {copyTextToSystemClipboard} from "../../../@excalidraw/packages/excalidraw/clipboard";
import {PROJECT_ID} from "@/views/Draw/DrawIndex";
import {loop, loopAllNode} from "@/TreeUtils";
import {nanoid} from "nanoid";
import {isZh} from "@/language";
import {shareCardData} from "@/views/Utils/CardUtils";

export const handleLibraryItemClick = async (szAction:string,item:any,callback:any)=>{
    return onCardItemClick(szAction,item,callback);
}
/**
 * 条目点击回调
 * @param szAction
 * @param item
 */
export const onCardItemClick = async (szAction:string,item:any,callback:any)=>{
    if (szAction == 'delete') {
        let szMsg = t("ConfirmDeleteLibraryItem");
        if (item.type == 'card'){
            szMsg = t("SureToDeleteTheCard")
        }
        window.showMessageBox(t("Tips"),szMsg,t('Cancel'),t("Delete"),null,()=>{
            window.closeMessageBox();

            item.isDeleted = 1;
            item.deleteTime = Date.now();
            updateCard(item).then(res=>{
                postMessage(EVENT_FAVIRIATE_CHANGE);
                postMessage(EVENT_REFRESH_RECENTS);
                postMessage(EVENT_DELETE_ELEMENT_BY_ID,{id:item.id});
                window.globalRefreshList();
            });
            //也删除highlight中的..
            dbGetHighlight(item.id).then(res=>{
                if (res){
                    res.isDeleted = 1;
                    res.deleteTime = item.deleteTime;
                    updateHighlight(res);
                }
            })

            //删除这个card所关联的项目
            deleteAllCardFromRefProject(item);

            //如果是视频注记，高亮删除也要更新
            if (item.type == 'videoAnno' || item.type == 'audioAnno'){
                dbGetHighlight(item.libraryId || item.id).then(r=>{
                    if (r){
                        //删除这个注记
                        const nIndex = r.data.findIndex(p=>p.id == item.id);
                        if (nIndex != -1){
                            r.data.splice(nIndex,1);
                            updateHighlight(r);
                        }
                    }
                })
            }

            //pdf注记删除，高亮删除也更新.
            if (item.type == 'pdfAnno'){
                ipcInvoke('remove-one-annotations',{id:item.id,pdfId:item.libraryId})
            }else if (item.type == 'cardAnno'){
                window.removeCardHighlight(item,()=>{
                    postMessage(EVENT_REFRESH_LIBRARY_LIST);
                });
            }

            const nIndex = arrayCardList.indexOf(item);
            var arrayNewCards = [...arrayCardList];
            arrayNewCards.splice(nIndex,1);

            setArrayCardList(arrayNewCards);
            //刷新数量
            const nNewCount = libraryCount - 1;
            setLibraryCount(nNewCount);
        })
    }else if (szAction == 'rename'){
        window.showCommonInput(item.name,t("Rename"),'',t("Cancel"),t("Save"),(szContent:string)=>{
            window.closeCommonInput();

            item.name = szContent;
            renameCard(item).then(res=>{
                //不知道啥排序，直接刷新列表。。
                // mPageNum.current = 0;
                // updateList();
                postMessage(EVENT_RENAME_LIBRARY_ITEM,{...item});
                if (isInPageTag()){
                    window.globalRefreshList('refresh_tableview_single_data_',item.id);
                }
            });
        });
    }else if (szAction == 'exportCardPdf'){
        //card to pdf
        const szHtmlDoc:any = await getCardDoc(item.id);
        editDoc(item.id,szHtmlDoc,item.name).then(res=>{
            setTimeout(() => {
                ipcSend('save-pdf-to-system', item.id, item.name)
            }, 10);
        })
    }else if (szAction == 'exportPdf' || szAction == 'exportVideo' || szAction == 'exportAudio' || szAction == 'exportFile'){
        //导出文件
        const szFilePath = localStorage.getItem(KEY_FILE_DIR) + item.fileName;
        ipcSend('saveFile', {
            filters: [{name: "All file", extensions: ['*']}],
            filePath: szFilePath,
            fileName: item.name+'.'+getFileNameExt(item.fileName)
        })
    }else if (szAction == 'shareCard'){
        window.showDialogPublishCardToWeb(item.id,(szId,dialogPublishToWebRef)=>{
            if (szId == 'exportPdf') {
                onCardItemClick('exportCardPdf',item,null);
            }else if (szId == 'exportMarkdown'){
                onCardItemClick('exportMarkdown',item,null)
            }
            else {
                shareCardData(item,null,dialogPublishToWebRef);
            }
        })
    }
    else if (szAction == 'managerTags'){
        //管理标签
        window.showManageTags([item]);
    }else if (szAction == 'addToProject'){
        //添加到project.
        window.showDialogChooseProject([item]);
    }else if (szAction == 'makeACopy'){
        const szHtml = await getCardDoc(item.id);
        const newItem = {
            ...item,
            id:generateUUID2(),
            name:item.name+"("+t("Copy")+")",
            doc:szHtml
        }
        updateCard(newItem).then(res=>{
            // mPageNum.current = 0;
            // updateList();
            message.info(t("Copyed"))
        });
    }else if (szAction == 'viewAllHighlights'){
        window.showPdfPreview(item.name,item.id,item.fileName,true,true)
    }else if (szAction == 'addToProjectChecked'){
        // addToProjectEvent();
    }else if (szAction == 'managerTagsChecked'){
        // managerTagsEvent();
    }else if (szAction == 'deleteChecked'){
        // deleteSelectedEvent();
    }else if (szAction == 'favor'){
        if (item.isFavirated){
            item.isFavirated = 0;
        }else{
            item.isFavirated = 1;
        }
        item.favirateTime = Date.now();
        item.sort = 0;
        updateCard(item,false).then(res=>{
            postMessage(EVENT_FAVIRIATE_CHANGE);
            // updateList();//刷新列表...
            // const arrayFavors = [...arrayCardList];
            // setArrayCardList(arrayFavors);
        });
    }else if (szAction == 'showInfo'){
        window.showInfo('library',item);
    }else if (szAction == 'versionHistory'){
        window.showDialogCardHistory(item.id);
    }
    else if (szAction == 'copyLink'){
        createCopyLinkByLibraryItem(item);
    }else if (szAction == 'select'){
        // //选择这一个...
        // if (item.type == 'add' && props.type == 'image'){
        //     //添加图片
        //     setIsShowDialogChooseImage(true);
        //     setTimeout(()=>{
        //         dialogChooseImageRef.current?.onShowDialog();
        //     },150);
        // }else if (item.type == 'add' && props.type == 'video'){
        //     setAcceptExt('.mp4,.mov');
        //     setTimeout(()=>{
        //         fileSelectRef.current?.click();
        //     },100)
        // }else if (item.type == 'add' && props.type == 'file'){
        //     setAcceptExt('*');
        //     setTimeout(()=>{
        //         fileSelectRef.current?.click();
        //     },100)
        // }
        // else{
        //     if (props.onItemSelectedCallback){
        //         if (item.type == 'card'){
        //             item.doc = await getCardDoc(item.id);
        //         }
        //         props.onItemSelectedCallback(item);
        //     }
        // }
    }else if (szAction == 'exportMarkdown'){
        window.exportMarkdown(item);
    }else if (szAction == 'add'){
        // onAddNewItem(item);
    }else if (szAction == 'edit'){
        // const doc = await getCardDoc(item.id);
        // Global.g_currentNoteData = {...item, doc};
        // openEditor(item.id,false,props.from == FROM_LIBRARY,props.from);
    }else if (szAction == 'showInSystemExporler'){
        ipcSend("show-in-exporler",((item.isAbsolutePath?'':localStorage.getItem(KEY_FILE_DIR)))+item.fileName)
    }else if (szAction == 'locateHighlight'){
        if (item.type == 'videoAnno' || item.type == 'audioAnno'){
            const highlight = await dbGetHighlightByLibraryId(item.libraryId);
            if (highlight) {
                window.showVideoNotes(highlight,item.id)
            }
        }else if (item.type == 'pdfAnno'){
            const library = await getCardById(item.libraryId);
            if (library) {
                window.showPdfPreview(library.name,library.id,library.fileName,false,true,true,{highlightId:item.id});
            }else {
                message.error(t("Open error"))
            }
        }else if (item.type == 'cardAnno'){
            openEditor(item.libraryId,true,false,'','card',item.id);
        }

    }else if (szAction == 'changeSource'){
        // changeSourceEvent(item);
    }else if (szAction == 'openInPopup'){
        if (item.type == 'video' || item.type == 'audio' || item.type == 'youtube' || item.type == 'bilibili' || item.type == 'baidu'){
            let highlight:any = await dbGetHighlight(item.id);
            if (!highlight){
                highlight = {...item};
            }
            window.showVideoNotes(highlight,null);
        }else if (item.type == 'pdf'){
            window.showPdfPreview(item.name,item.id,item.fileName,false);
        }else if (item.type == 'card'){
            const doc = await getCardDoc(item.id);
            item.doc = doc;
            window.showDialogCard(item);
        }
    }else if (szAction == 'openInFullscreen'){
        if (item.type == 'video' || item.type == 'audio' || item.type == 'youtube' || item.type == 'bilibili' || item.type == 'baidu'){
            let highlight:any = await dbGetHighlight(item.id);
            if (!highlight){
                highlight = {...item};
            }
            window.showVideoNotes(highlight,null,'fullScreen');
        }else if (item.type == 'pdf'){
            window.showPdfPreview(item.name,item.id,item.fileName,true);
        }else if (item.type == 'card'){
            window.navigate(getCardPath(),{cardId:item.id});
        }
    }else if (szAction == "importHighlights"){
        //导入--笔记
        window.showDialogImportHighlight(async (file,content)=>{
            let highlight:any = await dbGetHighlight(item.id);
            if (!highlight){
                highlight = {...item,data:[]};
            }
            onImportHighlights(file,content,highlight);
        });
    }else if (szAction == "exportHighlights"){
        //导出注记
        let highlight:any = await dbGetHighlight(item.id);
        if (!highlight){
            highlight = {...item,data:[]};
        }
        saveElementVideoNotesAsJSON(exportCurrentElementVideoNotes(highlight));
    }else if (szAction == "copyToClipboard"){
        //导出注记
        let highlight:any = await dbGetHighlight(item.id);
        if (!highlight){
            highlight = {...item,data:[]};
        }
        const text = getCurrentElementVideoNotes(highlight);
        await navigator.clipboard.writeText(text);
        message.info(t('Notes copied to clipboard'))
    }else if (szAction == 'copyOriginLink'){
        clipboard.write(item.fileName);
        message.info(t("Link copied to clipboard"));
    }else if (szAction == 'openLink'){
        ipcSend('open-url',item.fileName);
    }else if (szAction == 'copyHighlightText'){
        const library:any = await getCardById(item.id);
        let szNote = '';
        if (library?.comment){
            szNote = '\n' + t("Note")+":"+library?.comment
        }
        copyTextToSystemClipboard(library?.text + szNote);
    }
}

export const onProjectItemClick = async (szAction:any,data:any,callback:any)=>{
    switch (szAction) {
        case 'restore':
            // noteServer.restore(data.id)
            if (await hasBeyondFreeLimit()){
                postMessage(EVENT_SHOW_DESKTOP_PRO_VIP,{from:''});
                return;
            }
            data.isFavirated = 0;
            data.isDeleted = 0;
            data.updateTime = new Date().getTime();
            updateNote(data).then(res=>{
                postMessage(EVENT_NOTE_CHANGED);
                //刷新回收站
                postMessage(EVENT_NOTE_DELETE_FOREVER)
            })
            break;
        case 'favor':
            // noteServer.favitateNote(data.id)
            if (data.isFavirated == 1){
                data.isFavirated = 0;
            }else{
                data.isFavirated = 1;
            }
            // data.isFavirated = !data.isFavirated;
            data.favirateTime = new Date().getTime();
            updateNote(data).then(res=>{
                postMessage(EVENT_FAVIRIATE_CHANGE);
                // setMenuItems(createMenu());
            })
            break;
        case 'makeCopy':
            // noteServer.copy(data.id)
            if (await hasBeyondFreeLimit()){
                postMessage(EVENT_SHOW_DESKTOP_PRO_VIP,{from:''});
                return;
            }
            var noteCopy = {...data};
            noteCopy.id = generateRandomPageKey();
            noteCopy.name = noteCopy.showName = noteCopy.name+`(${t("Copy")})`;
            noteCopy.updateTime = new Date().getTime();
            noteCopy.createTime = Date.now();
            noteCopy.isFavirated = 0;
            const dbNote = await getNoteById(data.id);
            noteCopy.doc = dbNote?.doc;
            updateNoteItemToHasUpdate(noteCopy);
            updateNote(noteCopy).then(res=>{
                postMessage(EVENT_NOTE_CHANGED);
                if(window.refresh_tableview_){
                    window.refresh_tableview_();
                }
            })
            break;
        case 'rename':
            noteServer.rename(data)
            break;
        case 'delete':
            // const deleteRet = await confirmServer.open(t("Confirm delete"), t("Delete note can view trash"), t("Delete"))
            // if (deleteRet) {
            //   // noteServer.deleteNote(data.id)
            //   delNote(data);
            // }
            window.showMessageBox(t("Confirm delete"),t("Delete note can view trash"),t("Cancel"),t("Delete"),null,()=>{

                delNote(data).then(res=>{
                    postMessage(EVENT_REFRESH_TAG_LSIT);
                    postMessage(EVENT_NOTE_CHANGED);
                });
            })
            // postMessage(EVENT_SHOW_MESSAGE_BOX,data);
            break;
        case ENoteAction.permancentlyDelete:
            // const deleteRet2 = await confirmServer.open(t("Confirm delete forver"), t("Delete forver cant restore"), t("Delete forver"))
            // if (deleteRet2) {
            //   // noteServer.deleteFovever(data.id)
            //   delNoteForever(data.id);
            // }
            window.showMessageBox(t("Confirm delete forver"),t("Delete forver cant restore"),t("Cancel"),t("Delete forver"),null,()=>{
                delNoteForever(data.id);
            })
            break;
        case ENoteAction.moveToFolder:
            // dialogMovetoFolderRef?.current.onShowDialogEvent(data);
            // props.showMoveDialog(data);
            break;
        case 'manageTags':
            window.showManageTags([data]);
            break;
        case 'showInfo':
            getNoteById(data.id,false).then(res=>{
                window.showInfo('project',res);
            })
            break;
        case 'copyLink':
            createCopyLink('project',data.id)
            break;
        case 'changeThumbnail':
            window.showDialogChooseThumb(data,(newData)=>{

            })
            break;
    }
}



const canBeDelete = (szKey,menuData)=>{
    let isOnlyBoard = false;
    let nBoardCount = 0;
    let selectNode000 = null;
    loopAllNode(menuData,item=>{
        if (item.drawJson?.elements && !item.isFolder){
            nBoardCount ++;
        }
        if (szKey == item.key){
            selectNode000 = item;
        }
    })
    if (nBoardCount == 1){
        if (selectNode000.isFolder){
            //这个文件夹下是否有画布..
            let nChildBoardCount = 0;
            loopAllNode(selectNode000.children,(iiiiitttt)=>{
                if (!iiiiitttt.isFolder && iiiiitttt.drawJson?.elements){
                    nChildBoardCount ++;
                }
            })
            if (nChildBoardCount == 1){
                message.error(t('CantDeleteAll'));
                return false;
            }
        }else{
            message.error(t("Can not delete page"));
            return false;
        }
    }
    let parentNode = null;
    loop(menuData,szKey,(node, i, data, parent)=>{
        parentNode = parent;
    })

    if (menuData.length == 1 && !parentNode) {
        message.error(t('CantDeleteAll'));
        return false;
    };//只有一个不能删除...
    return true;
}
/**
 * 处理
 * @param szAction
 * @param data
 * @param callback
 */
export const onBoardItemClick = async (szAction:any,data:any,callback:any)=>{
    if ("makeCopy" == szAction) {
        const projectDoc = await getNoteJsonDoc(data.projectId);
        loop(projectDoc.canvas, data.id, (item, index, type, parent) => {
            var newItem = Object.assign({}, item);
            newItem.title = newItem.editValue = newItem.title + "(" + t("Copy") + ")"
            newItem.key = nanoid();
            newItem.drawJson = item.drawJson;

            if (parent != undefined) {
                parent.children.splice(index + 1, 0, newItem);
            } else {
                projectDoc.canvas.splice(index + 1, 0, newItem);
            }
            updateNoteDoc({id:data.projectId,doc:projectDoc});
            //刷新...
            const newBoard = {
                id:newItem.key,
                name:newItem.title,
                projectId:data.projectId,
                sort:data.sort,
                type:'board',
                tags:data.tags,
                isFavirated:data.isFavirated,
            }
            updateBoard(newBoard).then(res=>{
                window.globalRefreshList('refresh_tableview_single_data_',newBoard.id,{type:'board'});
                postMessage(EVENT_FAVIRIATE_CHANGE);
                if (callback){
                    callback('ok');
                }
            })
        });
    } else if ("rename" == szAction) {
        window.showCommonInput(data.name,t("Rename"),"",t("Cancel"),t("Save"),async (szContent)=>{
            data.name = szContent;

            const projectDoc = await getNoteJsonDoc(data.projectId);
            loop(projectDoc.canvas, data.id, (item) => {
                item.title = item.editValue = szContent;
                //更新
                updateNoteDoc({id:data.projectId,doc:projectDoc})
            });

            //更新..
            updateBoard(data).then(res=>{
                window.globalRefreshList('refresh_tableview_single_data_',data.id,{type:'board'});
                postMessage(EVENT_FAVIRIATE_CHANGE);
                if (callback){
                    callback('ok');
                }
            })

            window.closeCommonInput();
        })
    } else if ("delete" == szAction) {
        const projectDoc = await getNoteJsonDoc(data.projectId);
        if (!canBeDelete(data.id,projectDoc.canvas))return;

        {
            let msg = t("Delete canvas not restore");
            loop(projectDoc.canvas, data.id, (item, num, node, parent) => {
                // if (item.isFolder) {
                //     msg = t("DeleteTheFolder")
                // }

                window.showMessageBox(t("Tips"),msg,t("Cancel"),t("Delete"),null,()=>{
                    if (parent){
                        parent.children.splice(num,1);
                    }else{
                        projectDoc.canvas.splice(num,1);
                    }
                    //保存..
                    updateNoteDoc({id:data.projectId,doc:projectDoc});
                    //刷新列表...
                    data.isDeleted = 1;
                    data.isFavirated = 0;
                    updateBoard(data).then(res=>{
                        window.globalRefreshList('refresh_tableview_single_data_',data.id,{type:'board'});

                        //直接删了...
                        setTimeout(()=>{
                            deleteBoardById(data.id).then(rr=>{
                                postMessage(EVENT_FAVIRIATE_CHANGE);
                            });
                        },600)

                        if (callback){
                            callback('ok');
                        }
                    })

                })
            });

        }
    } else if ("moveTo" == szAction) {
        const projectDoc = await getNoteJsonDoc(data.projectId);
        loop(projectDoc.canvas, data.id, (item) => {
            window.showDialogBoardMoveTo(item,projectDoc.canvas,data.projectId,()=>{

            })
        });
    } else if ('favor' == szAction) {
        if (data.isFavirated == 1){
            data.isFavirated = 0;
        }else{
            data.isFavirated = 1;
        }
        // data.isFavirated = !data.isFavirated;
        data.favirateTime = new Date().getTime();
        updateBoard(data).then(res=>{
            postMessage(EVENT_FAVIRIATE_CHANGE);
            if (callback){
                callback('ok');
            }
        })
    }else if ('manageTags' == szAction){
        window.showManageTags([data]);
    }else if ('showInfo' == szAction){
        window.showInfo('project',data);
    }else if ('copyLink' == szAction){
        createCopyLink('project', data.projectId, "board", data.id);
    }
}